

import React, { useState } from "react";
import StarsQuestion from "./StarsQuestion";
import AdditionalQuestions from "./AdditionalQuestions";
import CustomerNameSurname from "./CustomerNameSurname";
import PrizeGameParticipation from "./PrizeGameParticipation";
import ConfirmButtonWithTermsOfUse from "./ConfirmButtonWithTermsOfUse";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { getObjectValue, setNestedValue } from "../../helpers/general";
import { useInsertReview } from "../../hooks/public/Invitations";
import ImageWithFallback from "../global/ImageWithFallback";
import { useSelectLanguage } from "../../hooks/global/Languages";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

function ReviewForm({ id, number = 0, title, subTitle, image, displayElementDetails, customerName, customerSurname, anonymous, questionsData, prizeGame, prizeGameVisible, termsVisible, data, onSubmit = null, lng }) { //{ vendor, customerName, customerSurname, prizeGame, profile, shouldReviewProfile, company }

	const { t } = useTranslation();

	const { mutate: insert } = useInsertReview();

	const [close, setClose] = useState(false);

	const [showProfileQuestions, setShowProfileQuestions] = useState(false);
	const [showPrizeGame] = useState(prizeGameVisible);

	const [error, setError] = useState(false);
	const [validateData, setValidateData] = useState({});
	const [review, setReview] = useState(data);
	const [deviceId, setDeviceId] = useState(false);

	const { selectTextByLanguage } = useSelectLanguage()

	const getValidateRules = () => {
		return [
			{ index: 'customerName', regex: /^.+$/s, condition: !anonymous },
			{ index: 'customerSurname', regex: /^.+$/s, condition: !anonymous },
			{ index: 'score', regex: /^(?:[0-5](?:\.[0-9]*)?)$/, condition: true },
			{ index: 'text', regex: /^.{15,}$/, condition: !!review.prize_game?.showPrizeGame && !!prizeGame?.participation_requirements?.reviewTextWritten },
			{ index: 'prize_game.termsAndConditions', regex: /^(true)$/i, condition: !!review.prize_game?.showPrizeGame },
			{ index: 'prize_game.email', regex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, condition: !!review.prize_game?.showPrizeGame },
		];
	}

	async function getDeviceId() {
		const fp = await FingerprintJS.load();
		const result = await fp.get();
		return result.visitorId;
	  }
	const scoreHandler = (id, score, index) => {
		setNestedValue(review, index, score);
		setReview(review);
		setShowProfileQuestions(true);
	}

	const handleReviewData = (index, value) => {

		let indexes = index.split(',');
		indexes.forEach((item) => {
			setNestedValue(review, item, value);
		});
	}

	const handleReviewDataPrizeGame = (index, value) => {
		value.name = review.customerName;
		value.surname = review.customerSurname;
		handleReviewData(index,value)
	}

	const handleSubmitProfile = (e) => {
		if (!validate(getValidateRules())) {

			review.device_id = deviceId;
			insert({ data: review, message: t('review.feed') });
			onSubmit?.();
			setClose(true);
		}
	}

	const validate = (indexes, regex) => {
		let e = false;
		let newValidateData = {};
		indexes.forEach(item => {
			if (item.condition) {
				let value = getObjectValue(review, item.index);
				if (item.regex.test(value)) {
					newValidateData[item.index] = true
				} else {
					newValidateData[item.index] = false
					e = true;
				}
			}
		});
		setValidateData(newValidateData);
		setError(e);
		return e;
	}
	getDeviceId().then((deviceId) => {
		setDeviceId(deviceId)
	  });

	return (
		<>
			{!close && <Form>
				<div className="reviewInvite-product clearfix">
					<div className="reviewInvite-productWrap">
						{number > 0 && <span className="productNumber">{number}</span>}
						<div className="col-md-12 no-padding clearfix">
							{title && <h1>{selectTextByLanguage(title, lng)}</h1>}
							{displayElementDetails && (
								<>
									{image && (<div className="productImage"> <ImageWithFallback src={image} alt={subTitle} /></div>)}
									{subTitle ? ( <h2 className="productTitle text-center">{selectTextByLanguage(subTitle, lng)}</h2>) : (<br />)}
								</>
					)}
						</div>
						<div className="row">
							<div className="col-md-12 no-padding mainStars">
								<div className="stars rate starsMainReview">
									<StarsQuestion id="score" index="score" value={-1} onChange={scoreHandler} />
								</div>
								{showProfileQuestions &&
									<div>
										<AdditionalQuestions
											index={'answers'}
											questions={questionsData}
											sourceId={id}
											onChange={handleReviewData} />

										<div className="row">
											<div className="col-md-12">
												<div className="margin-bottom-30 clearfix pt-3">
													<h2>{t("review.descXp")}</h2>
													<div className="reviewInvite-question reviewInvite-questionTextArea">
														<textarea id="description"
															name="description"
															rows={6}
															cols={40}
															placeholder={t("review.descPl")}
															onChange={(e) => handleReviewData("text", e.target.value)}
														/>
														{getObjectValue(validateData, 'text') === false && <p className="textareaRequired">{t("review.error.at")}</p>}
													</div>
												</div>



												{!customerName && !customerSurname && !anonymous &&

													<div className="unknownReview">
														<div>
															<h2>{t("review.op")}</h2>
															{<p className="caution"><em>{t("review.fl")}</em></p>}
															<div className="editMe-field">
																<CustomerNameSurname
																	index="customerName,prize_game.name"
																	text="review.name"
																	value={customerName}
																	onChange={handleReviewData}
																	validate={validateData} />
															</div>
															<div className="editMe-field editMe-fieldLastName">
																<CustomerNameSurname
																	index="customerSurname,prize_game.surname"
																	text="review.lastname"
																	value={customerSurname}
																	onChange={handleReviewData}
																	validate={validateData} />
															</div>
														</div>
													</div>

												}

												{showPrizeGame && prizeGameVisible && prizeGame &&
													<PrizeGameParticipation
														index='prize_game'
														onChange={handleReviewDataPrizeGame}
														validate={validateData}
														prizeGame={prizeGame}
														sourceId={id}
													/>
												}

												<ConfirmButtonWithTermsOfUse
													enabled={true}//{shouldReviewProfile}
													onSubmit={handleSubmitProfile}
													id={id}
													showTermsOfUse={termsVisible}
												/>
											</div>
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</Form>}
		</>);
}

export default ReviewForm;
